import Activity from "./Activity";
import ArchiveTarget from "./ArchiveTarget";
import Edit from "./Edit";
import LockInfo from "./LockInfo";
import Search from "./Search";
import SearchScope from "./SearchScope";
import View from "./View";
import Workflow from "./Workflow";
import Relations from "./Relations";

const FormBarItem = {
    Activity,
    ArchiveTarget,
    Edit,
    LockInfo,
    Search,
    SearchScope,
    View,
    Workflow,
    Relations,
};

export default FormBarItem;
